export const linkStyle = {
  paddingLeft: ".125rem",
  paddingRight: ".125rem",
  textDecoration: "none",
  cursor: "pointer"
};
